import { Component, Input, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';
import { ProductType, BoardType } from '../../core/core.types';
import {Observable} from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';
import { SimpleTravelService } from '../simple-travel.service';

@Component({
  selector: 'b4a-product-simple-travel-form-board-upgrades',
  templateUrl: './simple-travel-form-board-upgrades.component.html',
  styleUrls: ['../simple-travel-form-airports/simple-travel-form-airports.component.css']
})
export class SimpleTravelFormBoardUpgradesComponent {

  @Output() sendBoardCopyToParent: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendIdForDeleteBoard: EventEmitter<any> = new EventEmitter<any> ();
  @Output() sendValidBoard: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendSelectableBoard: EventEmitter<any> = new EventEmitter<any>();

  @Input() index: number;

  @Input() boards: any;

  @Input() boardTypes: any;

  @Input() lenghtOfBoards;

  @Input() selectedBoardTypes;

  change;

  constructor(public toastr: ToastrService,
    public simpleTravelService: SimpleTravelService) {
  }

  displayCurrentValue(event) {
      this.boards.price = Math.round(event * 100)
      if (this.boards.price === NaN) {
        this.boards.price = 0
      }
  }

  copyAuxiliary(auxiliary, index) {
    this.sendBoardCopyToParent.emit({auxiliary, index})
  }

  checkIfValid() {
    let len = this.lenghtOfBoards - 1;
    for (let i = 0; i <= len; i++) {
      let index = i.toString();
      document.getElementById('board-' + index).click();
    }
  }



  sendForm(boardForm: boolean) {
    if (!boardForm) {
      this.sendValidBoard.emit(false)
    }
  }


  deleteAuxiliary(index, boards) {
    var r = confirm('Are you sure?');
    if (r === true) {
        this.sendIdForDeleteBoard.emit({index, boards})
        // this.deleteAssignmentFromProduct
    }
  }

  boardChanged(event) {
    for (let board of this.selectedBoardTypes){
      if (board.code === this.boards.boardType) {
          board.selectable = true;
      }
      if (board.code === event) {
        board.selectable = false;
      }
    }
    this.sendSelectableBoard.emit(this.selectedBoardTypes)
  }

  SetValueOfPrice(price) {
        if (price !== '') {
          let extractDecimal = price.slice(price.length - 3, price.length - 2)
          if(extractDecimal === ','){
            let testPrice = price.slice(0, price.length - 3) + price.slice(price.length - 2, price.length)
            this.boards.price = Number(testPrice)
          }else{
            this.boards.price = Number(price * 100)
            this.boards.priceForAdmin += ',00'
          }
        }

      }
}



// WEBPACK FOOTER //
// ./src/app/product/simple-travel-form-board-upgrades/simple-travel-form-board-upgrades.component.ts